'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import H2 from 'UIComponents/elements/headings/H2';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIModal from 'UIComponents/dialog/UIModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getLangKey(key, isLive) {
  const prefix = isLive ? 'alreadyPublished' : 'allDrafts';
  return `pageSettings.mabPublishConfirmModal.${prefix}.${key}`;
}
const mabPublishConfirmModal = ({
  dismissCallback,
  isMasterLive,
  numberOfVariants,
  publishCallback
}) => /*#__PURE__*/_jsxs(UIModal, {
  style: {
    paddingTop: 42
  },
  use: "info",
  width: 540,
  children: [/*#__PURE__*/_jsx(UIDialogHeaderImage, {
    offsetBottom: -36,
    offsetTop: 84,
    children: /*#__PURE__*/_jsx(UIIllustration, {
      alt: I18n.text(getLangKey('illustration', isMasterLive)),
      name: "automated-testing",
      width: 125
    })
  }), /*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: dismissCallback
    }), /*#__PURE__*/_jsx(H2, {
      className: "center-block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('header', isMasterLive)
      })
    })]
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getLangKey('body', isMasterLive),
      options: {
        count: isMasterLive ? numberOfVariants - 1 : numberOfVariants
      }
    })
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    align: "center",
    children: [/*#__PURE__*/_jsx(UIButton, {
      onClick: publishCallback,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('confirmLabel', isMasterLive)
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: dismissCallback,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLangKey('dismissLabel', isMasterLive)
      })
    })]
  })]
});
mabPublishConfirmModal.propTypes = {
  dismissCallback: PropTypes.func.isRequired,
  isMasterLive: PropTypes.bool.isRequired,
  numberOfVariants: PropTypes.number,
  publishCallback: PropTypes.func.isRequired
};
export default mabPublishConfirmModal;